import type React from 'react';
import { Skeleton } from '@heroui/react';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';

/**
 * What a signed-in user sees while their organisation is read: a full-screen
 * placeholder with no shell, because until the read lands the gate does not
 * know whether the shell is theirs to see.
 */
export const OnboardingGateSkeleton: React.FC = () => (
    <div
        aria-busy
        className="flex min-h-screen items-center justify-center p-4"
        {...getNodeTestIdProp('onboarding-gate-loading')}
    >
        <div className="flex w-full max-w-md flex-col gap-4">
            <Skeleton className="h-8 w-2/3 rounded-lg" />
            <Skeleton className="h-4 w-full rounded-md" />
            <Skeleton className="h-4 w-5/6 rounded-md" />
            <Skeleton className="h-40 w-full rounded-xl" />
        </div>
    </div>
);
